import React from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "@/components/DataTable";
import { useTableActions } from "./hooks/useTableActions";
import { useLiveEventFilterOptions } from "./hooks/useLiveEventFilterOptions";
import { ChatChannel } from "@/__generated__/types";

interface CompletedEventsTableHeaderProps {
  onFilterChange: (filterId: string, values: string[]) => void;
  filterDisplayValue: string;
  availableChatChannels: ChatChannel[];
}

export const CompletedEventsTableHeader: React.FC<
  CompletedEventsTableHeaderProps
> = ({ onFilterChange, filterDisplayValue, availableChatChannels = [] }) => {
  const { t } = useTranslation();
  const { getCompletedActions } = useTableActions();

  const filterOptions = useLiveEventFilterOptions(availableChatChannels).filter(
    ({ id }) => id !== "audience",
  );

  return (
    <div className="flex w-full items-start justify-between p-6 pr-0">
      <div className="flex flex-col">
        <h1 className="text-[16px] font-semibold text-foreground">
          {t("gamesAndLiveEvents.table.completed.title")}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t("gamesAndLiveEvents.table.completed.subtitle")}
        </p>
      </div>
      <div className="flex flex-shrink-0 gap-2">
        <DataTable.Filter
          customFilters={filterOptions}
          onFilterChange={onFilterChange}
          displayValue={filterDisplayValue}
        />
        <DataTable.HeaderActions actions={getCompletedActions()} />
      </div>
    </div>
  );
};
